import '@babel/polyfill';

import Vue from 'vue';
import App from './App.vue';
import i18n from './i18n';
import VueRouter from 'vue-router';
Vue.use(VueRouter);
var router = new VueRouter({mode: 'history'});

import axios from 'axios';
import VueAxios from 'vue-axios';
Vue.use(VueAxios, axios);

if (process.env.NODE_ENV === 'development') {
    Vue.component('fa-icon', require('@fortawesome/fontawesome-free/css/all.css'));
}

import vueCustomElement from 'vue-custom-element';
Vue.use(vueCustomElement);
import 'document-register-element/build/document-register-element';

Vue.config.productionTip = false;

App.router = router;
App.i18n = i18n;
Vue.customElement('joutsenkivi-configurator', App);